import { Model } from '@vuex-orm/core';
import moment from 'moment';

export default class HuddleUser extends Model {
    static entity = 'huddle-user';

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(''),
            firstname: this.attr(''),
            lastname: this.attr(''),
            avatar: this.attr(''),
            username: this.attr(''),
            email: this.attr(''),
            fb_id: this.attr(''),
            follow_status: this.attr(''),
            created_at: this.attr(''),
            last_activity: this.attr(''),
            karma: this.attr(''),
            level: this.attr(''),
            banned: this.attr(false),
            posts: this.attr(0),
            answers: this.attr(0),
            topics: this.attr(0),
            likes: this.attr(0),
            isAdmin: this.attr(false),
            isModerator: this.attr(false),
            streak: this.attr(0),
            onfire: this.attr(false),
            comment_count: this.attr(0),
            progress: this.attr(0),
            roles: this.attr([]),
            achievements: this.attr([]),
            gender: this.attr(''),
            profile: this.attr({}),
            birth_date: this.attr(null),
            email_change: this.attr(null),
            onboarded: this.attr(0),
            verified: this.attr(0),
            settings: this.attr([]),
            user_level: this.attr(0),
            gamification: this.attr({}),
        };
    }

    static apiConfig = {
        actions: {
            findByUsername(username) {
                return new Promise((resolve, reject) => {
                    const params = new URLSearchParams();
                    params.append('find_by', 'username');

                    this.get(`/api/v3/profile/${username}`, {
                        params,
                        dataTransformer: response => response.data.data,
                    }).then((response) => {
                        resolve(response);
                    }).catch((err) => {
                        reject(err);
                    });
                });
            },

            me() {
                return new Promise((resolve) => {
                    this.get(`/api/v3/profile/me`, {
                        dataTransformer: response => {
                            const _data = response.data.data;
                            _data.birth_date = moment(_data.birth_date, "YYYY-MM-DD HH:mm:ss").format('YYYY-MM-DD');
                            return _data;
                        },
                    }).then((response) => {
                        resolve(response);
                    });
                });
            },

            update(data) {
                return new Promise((resolve, reject) => {
                    this.put(`/api/v3/profile`, {
                        ...data,
                        dataTransformer: response => response.data.data,
                    }).then((response) => {
                        resolve(response);
                    }).catch((error) => {
                        reject(error.response.data.message);
                    });
                });
            }
        }
    }
}

window.HuddleUser = HuddleUser;